var React = require('react');

function BluePisces (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.275,5.4343V1.9504c-6.0468,0-11.0693,4.4177-12.0402,10.1935h-2.1223C12.1407,6.3681,7.1192,1.9504,1.0714,1.9504v3.484c4.1195,0,7.5735,2.8675,8.4919,6.7095H2.1213v3.4831h7.559c-.6962,4.1276-4.2863,7.2852-8.6088,7.2852v3.484c6.2472,0,11.4065-4.7133,12.129-10.7692h1.9455c.7225,6.0559,5.8818,10.7692,12.129,10.7692v-3.484c-4.3225,0-7.9126-3.1576-8.6079-7.2852h7.0278v-3.4831h-6.9117c.9193-3.8421,4.3724-6.7095,8.4919-6.7095h-.0001Z","fill":"#f2e8b9","strokeWidth":"0"}));
}

BluePisces.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BluePisces;

BluePisces.default = BluePisces;
